import type { enPelayan } from '../en/pelayan';

export const idPelayan: Record<keyof typeof enPelayan, string> = {
  'pelayan.nav.tables': 'Meja',
  'pelayan.floor.subtitle': 'Pilih meja untuk memesan; sajikan yang sudah siap dari dapur.',
  'pelayan.ready.title': 'Siap disajikan',
  'pelayan.ready.description': 'Item yang sudah ditandai siap oleh dapur, per meja.',
  'pelayan.ready.empty': 'Belum ada yang siap — item muncul saat dapur menandainya siap.',
  'pelayan.ready.serveAll': 'Tandai semua tersaji',
  'pelayan.takeaway.title': 'Bawa pulang',
  'pelayan.takeaway.description':
    'Pesanan bawa pulang yang masih terbuka — ketuk untuk menambah item atau menyajikan.',
  'pelayan.takeaway.empty': 'Belum ada pesanan bawa pulang yang terbuka.',
  'pelayan.takeaway.items': '{count} item',
  'pelayan.order.back': 'Kembali ke meja',
  'pelayan.order.number': 'Pesanan {number}',
  'pelayan.order.closedNote': 'Pesanan ini sudah lunas dan selesai.',
  'pelayan.order.cancelledNote': 'Pesanan ini dibatalkan.',
};
